import React, { useContext } from 'react';
import HelpChatIcon from './HelpChatIcon';
import { useTranslation } from 'react-i18next';
import { en, fr } from './i18n';
import { openHelpPanel } from '../utils/openHelpPanel';
import Link from './Link';
import { CustomerServiceContext } from './CustomerServiceContext';

const CustomerServiceHelp = () => {
    const CUSTOMER_SERVICE_CENTER_TELEPHONE_NUMBER = '18882020888';

    const { i18n, t } = useTranslation('customer-service');
    i18n.addResourceBundle('en', 'customer-service', en, true, true);
    i18n.addResourceBundle('fr', 'customer-service', fr, true, true);

    const ctx = useContext(CustomerServiceContext);

    return (
        <div className="customer-service-faq__help">
            <HelpChatIcon width={43} height={40} />

            <h3 className="customer-service-faq__help__title">{t('stillNeedHelp')}</h3>

            <div className="customer-service-faq__help__subtitle">
                <p className="customer-service-faq__help__subtitle-text">{t('weOfferLiveChatAssistance')}</p>
                <p className="customer-service-faq__help__subtitle-text">{t('liveChatDate')}</p>
            </div>

            <button className="customer-service-faq__help__live-chat" onClick={openHelpPanel}>
                {t('liveChat')}
            </button>

            <div className="customer-service-faq__help__support">
                <span className="customer-service-faq__help__support-text">
                    {t('customerCareRepresentative')}{' '}
                    <a
                        className="customer-service-faq__help__support-text-link"
                        href={`tel:${CUSTOMER_SERVICE_CENTER_TELEPHONE_NUMBER}`}
                    >
                        {t('customerServiceCenter')}.
                    </a>
                </span>
                <span className="customer-service-faq__help__support-text">
                    {t('emailSupport')}.{' '}
                    <Link
                        href="/pages/customer-service/email-inquiry"
                        onClick={() => {
                            ctx.setView('article');
                            ctx.setContact('email-inquiry');
                            ctx.setUrlName('email-inquiry');
                        }}
                        className="customer-service-faq__help__support-text-link"
                    >
                        {t('sendUsEmail')}
                    </Link>
                </span>
            </div>
        </div>
    );
};

export default CustomerServiceHelp;
